import {
  SpanInfo,
  SpanInfoEnhanced,
  SymetraDateTime,
  SymetraDateTimeEnhanced
} from '@benefitsui/app/api/benefits-clients';

export class Defaults {
  static readonly dateFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone: 'UTC'
  } as Intl.DateTimeFormatOptions;

  static readonly dateFormatString = 'MM/dd/yyyy';
  static readonly sentinelValue = -1;
  static readonly stringEmpty = '';
  static readonly contactUsNumber = '1-866-216-7708';

  static readonly symetraDateTimeDefault = {
    unixMilliseconds: 0
  } as SymetraDateTime;

  static readonly symetraDateTimeEnhancedDefault = {
    unixMilliseconds: 0
  } as SymetraDateTimeEnhanced;

  static readonly timeoutMilliseconds = 3000;
  static readonly usLocale = 'en-US';

  static readonly spanInfoDefault = {
    begin: Defaults.symetraDateTimeDefault,
    end: Defaults.symetraDateTimeDefault
  } as SpanInfo;

  static readonly spanInfoEnhancedDefault = {
    begin: Defaults.symetraDateTimeEnhancedDefault,
    end: Defaults.symetraDateTimeEnhancedDefault
  } as SpanInfoEnhanced;
}
